
import { Component, Prop, VModel, Vue, Watch } from 'vue-property-decorator';

import moment from 'moment';

@Component
export default class TimeSelect extends Vue {
    @VModel() input!: string | null | undefined;
    @Prop({ default: null }) label!: string | null;
    @Prop({ default: false }) readonly!: boolean;

    time: string | null = null;

    get times(): string[] {
        // generated time strings 00:00 - 23:30, by 30 minutes
        const times = [];
        for (let i = 0; i < 24; i++) {
            for (let j = 0; j < 60; j = j + 30) {
                let time = i.toString().padStart(2, '0') + ':' + j.toString().padStart(2, '0');
                times.push(time);
            }
        }
        return times;
    }

    mounted() {
        this.time = this.input?.substring(0, 5) ?? null;
    }

    @Watch('time')
    timeChanged(v: string, p: string) {
        if (v == p) return;
        const isValueTimeString = /[0-9]{1,2}:[0-9]{2}/.test(v);
        const date = moment(v, 'HH:mm');
        const timeValue = isValueTimeString && date.isValid() ? date.format('HH:mm') : '';
        this.$emit('input', timeValue ? `${timeValue}:00` : null);
    }

    @Watch('input')
    inputChanged(v: string, p: string) {
        if (v == p) return;
        if (v == null) {
            this.time = null;
            return;
        } else {
            this.time = v.substring(0, 5);
        }
    }
}
